require([
    "../src/gallery.js",
], function() {});
